angular
    .module('annexaApp')
	.controller('DossierReasonsCloseController',['$scope', '$rootScope', 'CommonAdminModals', 'AnnexaFormlyFactory', 'CommonAdminService', 'AnnexaModalFactory', 'Language', '$filter', 'GlobalDataFactory', 'CacheFactory', 'apiAdmin', 'DialogsFactory', 'RestService',
    	function($scope, $rootScope, CommonAdminModals, AnnexaFormlyFactory, CommonAdminService, AnnexaModalFactory, Language, $filter, GlobalDataFactory, CacheFactory, apiAdmin, DialogsFactory, RestService) {

			$scope.filter = [
				{ id: Language.getActiveColumn(), type: 'text', order: 0, label: 'global.literals.name'},
				{ id: 'acronym', type: 'text', order: 1, label: 'global.literals.acronym'}
			];
			
			$scope.additionalColumns = [
				{ id: 'acronym', title: $filter('translate')('global.literals.acronym')}
			];

			$scope.newElement = function() {
				var modal = angular.copy(CommonAdminModals.dossierReasonsCloseNew);
				modal.annexaFormly.model = {};
				modal.annexaFormly.model.modal_body = {};
				modal.annexaFormly.options = {};
				
				AnnexaFormlyFactory.showModal('modalNewDossierReasonsClose', modal, $scope.saveDossierReasonsClose, false);
			}

			$scope.saveDossierReasonsClose = function (reasonClose) {
				var modal = this;
				
				var model = {
					language1: reasonClose.annexaFormly.model.modal_body.language1 ? reasonClose.annexaFormly.model.modal_body.language1 : 'NotTranslated',
					language2: reasonClose.annexaFormly.model.modal_body.language2 ? reasonClose.annexaFormly.model.modal_body.language2 : 'NotTranslated',
					language3: reasonClose.annexaFormly.model.modal_body.language3 ? reasonClose.annexaFormly.model.modal_body.language3 : 'NotTranslated',
					acronym: reasonClose.annexaFormly.model.modal_body.acronym
				}
				
				RestService.insert('./api/tram/dossierReasonsClose/', model).then(function () {
					$rootScope.$broadcast('annexaAdminBaseReloadTable'); 
					modal.close();
				}).catch(function (error) {
					modal.alerts.push({ msg: $filter('translate')('global.errors.errorDossierReasonsClose')});
				})
			}

			$scope.viewElement = function (id) {
				RestService.findOne('DossierReasonsClose', id).then(function(data) {
					var decodeddata = JSOG.decode(data.data);
					
					var modal = angular.copy(CommonAdminModals.dossierReasonsCloseEdit);
					modal.alerts = [];
					modal.data = decodeddata;
					modal.languageColumn = Language.getActiveColumn();
					modal.updateDossierReasonsClose = $scope.updateDossierReasonsClose;
					
					AnnexaModalFactory.showModal('modalDossierReasonsCloseEdit', modal);
				});
			}

			$scope.updateDossierReasonsClose = function(val, prop) {
				var self = this;
				var model = angular.copy(this.data);
				
				RestService.update('./api/tram/dossierReasonsClose/' + model.id, model).then(function (data) {
					$rootScope.$broadcast('annexaAdminBaseReloadTable');
				}).catch(function (error) {
					DialogsFactory.error($filter('translate')('global.errors.errorDossierReasonsClose'), $filter('translate')('DIALOGS_ERROR_MSG'));
				});
			}
	}])